














































import { Component, Vue } from 'vue-property-decorator';
import { ServiceRequestModel } from '../../types/request';
import { MedTransGoConstants } from '../../util/constants';
import { required, integer, minValue, maxValue } from 'vuelidate/lib/validators';
import { ModelSelect } from 'vue-search-select';
// tslint:disable-next-line: no-var-requires
const validationErrorMessages = require('../../config/validationErrorMessages.json');

@Component({
    props: {
        serviceRequest: Object,
    },
    components: {
        ModelSelect,
    },
    data() {
        return {
            validationErrorMessages: [],
            showRequiredFieldMessage: false,
            formValidation: {
                isHealthCareHoursValid: false,
                isHomeHealthCareHoursValid: true,
                isHomeHealthCareHoursErrorMessage: '',
                isHomeHealthCareMinutesValid: true,
                isHomeHealthCareMinutesErrorMessage: '',
                isFormValid: false,
            },
        };
    },
    methods: {
        validateHours() {
            const hours = this.$props.serviceRequest.homeHealthCare.estimatedVisitTime.hours;
            if (hours > 23 || hours < 0) {
                this.$data.formValidation.isHomeHealthCareHoursValid = false;
                this.$data.formValidation.isHomeHealthCareHoursErrorMessage = 'Please enter a valid number between 0 and 23 for hours.';
            } else {
                this.$data.formValidation.isHomeHealthCareHoursValid = true;
                this.$data.formValidation.isHomeHealthCareHoursErrorMessage = '';
            }
        },
        validateMinutes() {
            const minutes = this.$props.serviceRequest.homeHealthCare.estimatedVisitTime.minutes;
            if (minutes > 59 || minutes < 0) {
                this.$data.formValidation.isHomeHealthCareMinutesValid = false;
                this.$data.formValidation.isHomeHealthCareMinutesErrorMessage = 'Please enter a valid number between 0 and 59 for minutes.';
            } else {
                this.$data.formValidation.isHomeHealthCareMinutesValid = true;
                this.$data.formValidation.isHomeHealthCareMinutesErrorMessage = '';
            }
        },
        restrictToNumbers(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode < 48 || charCode > 57) {
            event.preventDefault();
            }
        },
    },
    validations(): any {
        const validations: any = {
            serviceRequest: {
                homeHealthCare: {
                    serviceType: {
                        required,
                    },
                    estimatedVisitTime: {
                        hours: {
                            required,
                            minValue: minValue(1),
                            integer,
                            maxValue: maxValue(24),
                        },
                        minutes: {
                            minValue: minValue(0),
                            integer,
                            maxValue: maxValue(60),
                        },
                    },
                },
            },
        };
        this.$data.validationErrorMessages = [];

        const isEmpty = (value: any) => {
            return value === undefined || value === null || value === '' || value <= 0;
        };

        const checkFields = (data: any, validationRules: any, path = '') => {
            Object.keys(validationRules).forEach((fieldName) => {
                const fieldValidation = validationRules[fieldName];
                const fieldPath = path ? `${path}.${fieldName}` : fieldName;

                if (fieldValidation.required) {
                        const fieldValueInData = getField(data, fieldPath);
                        if (isEmpty(fieldValueInData)) {
                            const keys = fieldPath.split('.');
                            let value = validationErrorMessages;
                            for (const key of keys) {
                                value = value[key];
                            }
                            if (value) {
                                this.$data.validationErrorMessages.push(value);
                            }
                        }
                }
                if (typeof fieldValidation === 'object') {
                    checkFields(data, fieldValidation, fieldPath);
                }
            });
        };

        // Function to get nested field value from data
        const getField = (data: any, fieldPath: any) => {
            const pathArray = fieldPath.split('.');
            let value = data;
            for (const pathItem of pathArray) {
                if (!value) {
                    return undefined;
                }
                value = value[pathItem];
                if (value === undefined) {
                    break;
                }
            }
            return value;
        };
        checkFields(this.$props.serviceRequest, validations.serviceRequest);
        return validations;
    },
})
export default class HomeHealthCareServiceDetails extends Vue {

    private mounted() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (!serviceRequest.stops.isStop1Valid) {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_SERVICE_VISIT });
            return;
        }
        if (serviceRequest.service.selectedType !== 'HomeHealthCare') {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_SERVICE_VISIT });
            return;
        }
        this.validateForm();
    }


    private nextStep() {
        if (this.$v.$invalid) {
            this.$data.showRequiredFieldMessage = true;
        } else {
            this.$props.serviceRequest.stops.isStop2Valid = true;
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_ADDRESS_BILLING });
        }
    }

    private preStep() {
       this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_SERVICE_VISIT });
    }

    private validateForm() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.homeHealthCare) {
            this.$data.formValidation.isFormValid = false;

            if ((!serviceRequest.homeHealthCare.estimatedVisitTime.hours
                || serviceRequest.homeHealthCare.estimatedVisitTime.hours <= 0)) {
                this.$data.formValidation.isHealthCareHoursValid = false;
            } else {
                this.$data.formValidation.isHealthCareHoursValid = true;
            }
            this.$data.formValidation.isFormValid = this.$data.formValidation.isHealthCareHoursValid;
        }
    }

}
